import styled from 'styled-components'

const FakeInput = styled.div`
  padding: 0.5em;
  line-height: 1.2142em;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 3px;
  min-height: 32px;
`

export default FakeInput
